import React, { Fragment, useState, useEffect } from "react";
import { Field } from 'formik';
import TimeField from 'react-simple-timefield';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
export default ({ name, placeholderText, type, disabled, minTime, startTime, locationState, editResponse, prePopulateState, endTime, props, edit, fromValue, toValue, profileResponse, selectedValue, onChangeHandler }) => {
    let currentDate = new Date()
    let setTimeVal = '08:00'

    const listForHandleChange = ["postLoadDeliveryWindowBegin", "postLoadDeliveryWindowEnd", "postLoadBidCloseTime", "deliveryWindowBegin", "deliveryWindowEnd", "postOpearinalHoursBegin", "postOpearinalHoursEnd", "pickupWindowBegin", "pickupWindowEnd", "bidTime", "beginTimeCheckOut", "endTimeCheckOut", "appt", "AppointmentWindowFrom", "AppointmentWindowTo", "brokerOperationEndTime", "brokerOperationStartTime", "checkOutStartTimeBuyerOffer", "checkOutAltStartTimeBuyerOffer", "checkOutAltEndTimeBuyerOffer", "checkOutEndTimeBuyerOffer", "rescheduleFromTime", "rescheduleToTime"]

    if (fromValue) {
        if (edit) {
            setTimeVal = edit
        } else {
            setTimeVal = '00:00'
        }

    }
    if (toValue) {
        if (edit) {
            setTimeVal = edit
        } else {
            setTimeVal = toValue
        }
    }

    if (name === "deliveryWindowBegin" || name === 'postOpearinalHoursBegin') {
        if (editResponse && editResponse.locationDetail && editResponse.locationDetail.defaultProfile && editResponse.locationDetail.defaultProfile.officeHourStart) {
            let setbidTimeArr = editResponse.locationDetail.defaultProfile.officeHourStart.split(':')
            // let pickupStartTime = editResponse.locationDetail.defaultProfile.officeHourStart

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
            currentDate.setHours(setHours)
            currentDate.setMinutes(setMinutes)
        } else if (type === "createPost" && editResponse && editResponse.deliveryWindowBegin) {
            let setbidTimeArr = editResponse.deliveryWindowBegin.split(':')
            // let pickupStartTime = editResponse.deliveryWindowBegin

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
            currentDate.setHours(setHours)
            currentDate.setMinutes(setMinutes)
        }
        else {
            currentDate.setHours(8)
            currentDate.setMinutes(0)
            setTimeVal = '08:00'
        }
    }
    if (name === "deliveryWindowEnd" || name === 'postOpearinalHoursEnd') {
        if (editResponse && editResponse.locationDetail && editResponse.locationDetail.defaultProfile && editResponse.locationDetail.defaultProfile.officeHourEnd) {
            let setbidTimeArr = editResponse.locationDetail.defaultProfile.officeHourEnd.split(':')
            // let pickupStartTime = editResponse.locationDetail.defaultProfile.officeHourEnd

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }

            setTimeVal = setHours + ':' + setMinutes
            currentDate.setMinutes(setMinutes)
            currentDate.setMinutes(setMinutes)
        } else if (type === "createPost" && editResponse && editResponse.deliveryWindowEnd) {
            let setbidTimeArr = editResponse?.deliveryWindowEnd.split(':')
            // let pickupStartTime = editResponse?.deliveryWindowEnd

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }

            setTimeVal = setHours + ':' + setMinutes
            currentDate.setMinutes(setMinutes)
            currentDate.setMinutes(setMinutes)
        } else {
            currentDate.setHours(17)
            currentDate.setMinutes(0)
            setTimeVal = '17:00'
        }
    }
    if (name === "beginTimeCheckOut") {
        currentDate.setHours(8)
        currentDate.setMinutes(0)
        setTimeVal = '08:00'
    }
    if (name === "beginTimeCheckOut") {
        if (prePopulateState?.postInventory?.brokerOfficeHourStart && prePopulateState?.type !== "buynow") {
            let setbidTimeArr = prePopulateState?.postInventory?.brokerOfficeHourStart.split(':')
            // let pickupStartTime = profileResponse?.deliveryWindowBegin

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else {
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.postInventory?.isDeliveryAvailable && prePopulateState?.type === "buynow") {
                if (profileResponse?.deliveryWindowBegin) {
                    let setbidTimeArr = profileResponse?.deliveryWindowBegin.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.postInventory?.isDeliveryAvailable && prePopulateState?.type !== "buynow") {
                if (prePopulateState?.postInventory?.officeHourStart) {

                    let setbidTimeArr = prePopulateState?.postInventory?.officeHourStart.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.postInventory?.isDeliveryAvailable) {
                if (prePopulateState?.postInventory?.officeHourStart) {

                    let setbidTimeArr = prePopulateState?.postInventory?.officeHourStart.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }

    }
    if (name === "endTimeCheckOut") {
        if (prePopulateState?.postInventory?.brokerOfficeHourEnd && prePopulateState?.type !== "buynow") {
            let setbidTimeArr = prePopulateState?.postInventory?.brokerOfficeHourEnd.split(':')
            // let pickupStartTime = profileResponse?.deliveryWindowBegin

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else {
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.postInventory?.isDeliveryAvailable && prePopulateState?.type === "buynow") {
                if (profileResponse?.deliveryWindowEnd) {
                    let setbidTimeArr = profileResponse?.deliveryWindowEnd.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.postInventory?.isDeliveryAvailable && prePopulateState?.type !== "buynow") {
                if (prePopulateState?.postInventory?.officeHourEnd) {
                    let setbidTimeArr = prePopulateState?.postInventory?.officeHourEnd.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.postInventory?.isDeliveryAvailable) {
                if (prePopulateState?.postInventory?.officeHourEnd) {
                    let setbidTimeArr = prePopulateState?.postInventory?.officeHourEnd.split(':')
                    // let pickupStartTime = profileResponse?.deliveryWindowBegin

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }


    }
    if (name === "pickupWindowBegin") {
        currentDate.setHours(8)
        currentDate.setMinutes(0)
        setTimeVal = '08:00'
    }
    if (name === "pickupWindowBegin") {
        if (prePopulateState?.brokerOfficeHourStart && prePopulateState?.postType === "postInventory") {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourStart.split(':')

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else {
            if (prePopulateState?.postType === "postLoad") {
                if (profileResponse?.officeHourStart) {
                    let setbidTimeArr = profileResponse?.officeHourStart.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourStart) {

                    let setbidTimeArr = prePopulateState?.officeHourStart.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourStart) {

                    let setbidTimeArr = prePopulateState?.officeHourStart.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }

    }
    if (name === "pickupWindowEnd") {
        currentDate.setHours(17)
        currentDate.setMinutes(0)
        setTimeVal = '17:00'
    }
    if (name === "pickupWindowEnd") {
        if (prePopulateState?.brokerOfficeHourEnd && prePopulateState?.postType === "postInventory") {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourEnd.split(':')
            // let pickupStartTime = profileResponse?.deliveryWindowBegin

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else {
            if (prePopulateState?.postType === "postLoad") {
                if (profileResponse?.officeHourEnd) {
                    let setbidTimeArr = profileResponse?.officeHourEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourEnd) {
                    let setbidTimeArr = prePopulateState?.officeHourEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourEnd) {
                    let setbidTimeArr = prePopulateState?.officeHourEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }
    }

    if (name === "requestedStartTime") {// && startTime === null
        currentDate.setHours(8)
        currentDate.setMinutes(0)
        setTimeVal = '08:00'
    }
    if (name === "requestedStartTime") {// && startTime && startTime !== null
        if (prePopulateState?.brokerOfficeHourStart && prePopulateState?.postType === "postLoad" && !prePopulateState?.pickup) {//postLoad
            let setbidTimeArr = prePopulateState?.brokerOfficeHourStart.split(':')

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
        } else if (prePopulateState?.brokerOfficeHourStart && prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourStart.split(':')

            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
        } else {
            if (prePopulateState?.postType === "postLoad" && !prePopulateState?.deliverable) {
                if (profileResponse?.officeHourStart) {
                    let setbidTimeArr = profileResponse?.officeHourStart.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
                if (profileResponse?.deliveryWindowBegin) {
                    let setbidTimeArr = profileResponse?.deliveryWindowBegin.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                } else { }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                if (profileResponse?.deliveryWindowBegin) {
                    let setbidTimeArr = profileResponse?.deliveryWindowBegin.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourStart) {
                    let setbidTimeArr = prePopulateState?.officeHourStart.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }
    }

    if (name === "requestedEndTime" && endTime === null) {
        currentDate.setHours(17)
        currentDate.setMinutes(0)
        setTimeVal = '17:00'
    }
    if (name === "requestedEndTime") {//&& endTime !== null
        if (prePopulateState?.brokerOfficeHourEnd && prePopulateState?.postType === "postLoad" && !prePopulateState?.pickup) {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourEnd.split(':')
            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else if (prePopulateState?.brokerOfficeHourEnd && prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourEnd.split(':')
            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
        } else {
            if (prePopulateState?.postType === "postLoad" && !prePopulateState?.deliverable) {
                if (profileResponse?.officeHourEnd) {
                    let setbidTimeArr = profileResponse?.officeHourEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
                if (profileResponse?.deliveryWindowEnd) {
                    let setbidTimeArr = profileResponse?.deliveryWindowEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                if (profileResponse?.deliveryWindowEnd) {
                    let setbidTimeArr = profileResponse?.deliveryWindowEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
            if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                if (prePopulateState?.officeHourEnd) {
                    let setbidTimeArr = prePopulateState?.officeHourEnd.split(':')
                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                }
            }
        }
    }

    let setTime = new Date(currentDate)

    if (name === "deliveryWindowBegin" && !editResponse) {
        if (prePopulateState?.brokerOfficeHourStart && prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourStart.split(':')
            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes
        } else {
            if (profileResponse) {
                if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                    if (profileResponse?.deliveryWindowBegin) {
                        let setbidTimeArr = profileResponse?.deliveryWindowBegin.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
                if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                    if (profileResponse?.deliveryWindowBegin) {
                        let setbidTimeArr = profileResponse?.deliveryWindowBegin.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
                if (prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
                    if (prePopulateState?.deliveryWindowBegin) {
                        let setbidTimeArr = prePopulateState?.deliveryWindowBegin.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
            } else {
                if (prePopulateState && prePopulateState?.deliveryWindowBegin) {
                    let setbidTimeArr = prePopulateState?.deliveryWindowBegin.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                } else {
                    if (prePopulateState && prePopulateState?.appointmentStartTime) {
                        let setbidTimeArr = prePopulateState?.appointmentStartTime.split(':')

                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
            }
        }
    }
    if (name === "deliveryWindowEnd" && !editResponse) {
        if (prePopulateState?.brokerOfficeHourEnd && prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
            let setbidTimeArr = prePopulateState?.brokerOfficeHourEnd.split(':')
            let setHours = setbidTimeArr[0]
            let setMinutes = setbidTimeArr[1]
            if (setbidTimeArr[0].length === 1) {
                setHours = 0 + setbidTimeArr[0]
            }
            if (setbidTimeArr[1].length === 1) {
                setMinutes = 0 + setbidTimeArr[1]
            }
            setTimeVal = setHours + ':' + setMinutes

        } else {
            if (profileResponse) {
                if (prePopulateState?.postType === "postInventory" && prePopulateState?.isDeliveryAvailable) {
                    if (profileResponse?.deliveryWindowEnd) {
                        let setbidTimeArr = profileResponse?.deliveryWindowEnd.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
                if (prePopulateState?.postType === "postInventory" && !prePopulateState?.isDeliveryAvailable) {
                    if (profileResponse?.deliveryWindowEnd) {
                        let setbidTimeArr = profileResponse?.deliveryWindowEnd.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
                if (prePopulateState?.postType === "postLoad" && prePopulateState?.deliverable) {
                    if (prePopulateState?.deliveryWindowEnd) {
                        let setbidTimeArr = prePopulateState?.deliveryWindowEnd.split(':')
                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
            }
            else {
                if (prePopulateState && prePopulateState?.deliveryWindowEnd) {
                    let setbidTimeArr = prePopulateState?.deliveryWindowEnd.split(':')

                    let setHours = setbidTimeArr[0]
                    let setMinutes = setbidTimeArr[1]
                    if (setbidTimeArr[0].length === 1) {
                        setHours = 0 + setbidTimeArr[0]
                    }
                    if (setbidTimeArr[1].length === 1) {
                        setMinutes = 0 + setbidTimeArr[1]
                    }
                    setTimeVal = setHours + ':' + setMinutes
                } else {
                    if (prePopulateState && prePopulateState?.appointmentEndTime) {
                        let setbidTimeArr = prePopulateState?.appointmentEndTime.split(':')

                        let setHours = setbidTimeArr[0]
                        let setMinutes = setbidTimeArr[1]
                        if (setbidTimeArr[0].length === 1) {
                            setHours = 0 + setbidTimeArr[0]
                        }
                        if (setbidTimeArr[1].length === 1) {
                            setMinutes = 0 + setbidTimeArr[1]
                        }
                        setTimeVal = setHours + ':' + setMinutes
                    }
                }
            }
        }
    }
    if (name === "appt") {
        if (prePopulateState && type === "createPost" && !editResponse?.deliveryWindowBegin && editResponse?.appt1) {
            setTimeVal = editResponse?.appt1
        }
    }

    if (name === "bidTime" && editResponse && editResponse?.bidCloseTime) {
        let getTime = editResponse?.bidCloseTime.split('T')
        setTimeVal = getTime[1]
    }
    if (name === "bidTime" && editResponse && !editResponse?.bidCloseTime) {
        let setState = locationState;
        let nDate;
        if (setState === "California" || setState === "California ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Los_Angeles").format('HH:mm');
        }
        else if (setState === "Alaska" || setState === "Alaska ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("US/Alaska").format('HH:mm');
        } else if (setState === "American Samoa") {
            const moment = require('moment-timezone');
            nDate = moment().tz("American/American Samoa").format('HH:mm');
        } else if (setState === "Washington") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Washington").format('HH:mm');
        }
        else if (setState === "Arizona") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Phoenix").format('HH:mm');
        }
        else {
            nDate = new Date().toLocaleString('en-US', {
                timeZone: 'US/' + timeZoneFun(setState)
            });
            let getTime = new Date(nDate)
            let setHours = getTime.getHours()
            let setMinutes = getTime.getMinutes()
            if (setHours.toString().length === 1) {
                setHours = '0' + setHours
            }
            if (setMinutes.toString().length === 1) {
                setMinutes = '0' + setMinutes
            }
            nDate = setHours + ':' + setMinutes
        }
        setTimeVal = nDate
    }

    if (name === "bidTime" && !editResponse) {
        let setState = locationState;
        let nDate;

        if (setState === "California" || setState === "California ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Los_Angeles").format('HH:mm');
        }
        else if (setState === "Alaska" || setState === "Alaska ") {
            const moment = require('moment-timezone');
            nDate = moment().tz("US/Alaska").format('HH:mm');
        } else if (setState === "American Samoa") {
            const moment = require('moment-timezone');
            nDate = moment().tz("American/American Samoa").format('HH:mm');
        } else if (setState === "Washington") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Washington").format('HH:mm');
        }
        else if (setState === "Arizona") {
            const moment = require('moment-timezone');
            nDate = moment().tz("America/Phoenix").format('HH:mm');
        }
        else {
            nDate = new Date().toLocaleString('en-US', {
                timeZone: 'US/' + timeZoneFun(setState)
            });
            let getTime = new Date(nDate)
            let setHours = getTime.getHours()
            let setMinutes = getTime.getMinutes()
            if (setHours.toString().length === 1) {
                setHours = '0' + setHours
            }
            if (setMinutes.toString().length === 1) {
                setMinutes = '0' + setMinutes
            }
            nDate = setHours + ':' + setMinutes
        }
        setTimeVal = nDate
    }
    let hoursMintes = setTimeVal;

    if (!editResponse) {
        let setHours = setTime.getHours();
        let setMinutes = setTime.getMinutes();
        let startTimeVal = setHours + ':' + setMinutes

        let setArrVal = startTimeVal.split(':')

        if (setArrVal[0].length === 1) {
            setHours = 0 + setArrVal[0]
        }
        if (setArrVal[1].length === 1) {
            setMinutes = 0 + setArrVal[1]
        }
        hoursMintes = setHours + ':' + setMinutes
    }
    const [selectedTime, handleTimeChange] = useState();
    useEffect(() => {
        if (selectedValue) handleTimeChange(selectedValue)
    }, [selectedValue])

    if (disabled === undefined) disabled = false;
    const changeHandler = (name, setFieldValue, setFieldError, time) => {
        let setTime = time.target.value;
        let dateSet = new Date();
        let selectedTime = new Date(`1970-01-01T${setTime}`);

        if (selectedTime <= new Date(`1970-01-01T00:00`)) {
            setFieldError(name, "Please enter valid Time.");
            setFieldValue(name, setTime);
        } else {
            if (listForHandleChange?.includes(name)) {
                handleTimeChange(setTime);
                setFieldValue(name, setTime);
            } else if (name === "requestedStartTime" || name === "requestedEndTime") {
                if (props.values.requestedStartTime === setTime || setTime === props.values.requestedEndTime) {
                } else {
                    handleTimeChange(setTime);
                    setFieldValue(name, setTime);
                }
            } else {
                if (dateSet <= setTime) {
                    handleTimeChange(setTime);
                    setFieldValue(name, setTime);
                } else {
                    if (fromValue || toValue) {
                        setFieldValue(name, setTime);
                    } else {
                        setFieldError(name, "Cannot select less time");
                    }
                }
            }
        }
    }

    return (
        <div>
            <Field name={name}>
                {({ field, form, meta }) => {
                    return (
                        <Fragment>
                            <div className='custom-date-piker'>
                                <div
                                    className={`app-input-text ${meta.touched && meta.error ? 'error' : ''}`}
                                >
                                    <TimeField
                                        disabled={disabled}
                                        className='s-input -time'
                                        name={name}
                                        value={selectedTime ? selectedTime : setTimeVal}
                                        onChange={(time) => {
                                            changeHandler(name, form.setFieldValue, form.setFieldError, time)
                                            if (onChangeHandler) onChangeHandler()
                                        }} />
                                </div>

                            </div>
                            {meta.error && <p name={name} className="error-message">{meta.error}</p>}
                        </Fragment>
                    );
                }}
            </Field>

        </div>
    );
};